import { QUALITY_SERVICE_API_URL } from '../config';
import { useEffect, useState } from 'react';
import api from '../api';

const getNewFailures = async (date, selectedEnvironment, selectedPackage, selectedFramework, isCsqXp) => {
  try {
    // Convert 'All app packages' to 'app' for the API
    const packageParam = selectedPackage.toLowerCase() === 'all packages' ? 'app' : selectedPackage.toLowerCase();

    const body = {
      date: date,
      env: selectedEnvironment.toLowerCase(),
      package: packageParam,
      framework: selectedFramework.toLowerCase(),
    };
    if (isCsqXp !== null) {
      body.isCsqXp = isCsqXp;
    }

    const response = await api.post(`${QUALITY_SERVICE_API_URL}/hub/new-failures`, body);
    return response.data;
  } catch (error) {
    console.error('Error fetching new failures:', error);
    throw error;
  }
};

const useNewFailures = (selectedDate, selectedEnvironment, selectedPackage, selectedFramework, isCsqXp = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const date = selectedDate.toISOString().split('T')[0];

      try {
        const result = await getNewFailures(date, selectedEnvironment, selectedPackage, selectedFramework, isCsqXp);
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, selectedEnvironment, selectedPackage, selectedFramework, isCsqXp]);

  return { data, loading, error };
};

export default useNewFailures; 